export default __webpack_public_path__ + "static/media/grau.11ec36b5.jpeg";